import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Header from './components/Header';
import Index  from './components';
import Login from './components/login';
import WebSocketProvider from './utils/SocketContext'; // Import the WebSocketProvider

const App = () => {
  return (
    <WebSocketProvider>
      <Router>
        <Header />
        <Routes>
          <Route path="/" />
          <Route path="/traffic" />
          <Route path="/contact-us" />
          <Route path="/account" />
          <Route path="/login" element={<Login />} />
        </Routes>
      </Router>
      <Index/>
    </WebSocketProvider>
  );
};

export default App;
